export default __webpack_public_path__ + "static/media/logo.d705b2cc.svg";